<template>
  <v-flex xs12 class="audit-container" pa-2>
    <v-card>
      <v-layout row wrap>
        <v-flex xs12 sm5 d-flex class="question">
          <slot name="question"></slot>
        </v-flex>

        <v-flex xs12 sm7 class="findings">
          <v-flex xs12>
            <slot name="findings"></slot>
          </v-flex>

          <v-flex xs12>
            <slot name="createfinding"></slot>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  mounted() {
    //console.log("Audit Execution", "AUDIT ITEM ROWS MOUNTED");
  }
};
</script>
